export const TierInfiniteIcon = ({ width = 29, height = 29, color = "#fff" }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 29 29"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7.25 19.3333C13.2917 19.3333 15.7083 9.66667 21.75 9.66667C23.0319 9.66667 24.2613 10.1759 25.1677 11.0823C26.0741 11.9887 26.5833 13.2181 26.5833 14.5C26.5833 15.7819 26.0741 17.0113 25.1677 17.9177C24.2613 18.8241 23.0319 19.3333 21.75 19.3333C15.7083 19.3333 13.2917 9.66667 7.25 9.66667C5.96812 9.66667 4.73874 10.1759 3.83232 11.0823C2.92589 11.9887 2.41667 13.2181 2.41667 14.5C2.41667 15.7819 2.92589 17.0113 3.83232 17.9177C4.73874 18.8241 5.96812 19.3333 7.25 19.3333Z"
      stroke={color}
      strokeWidth={2}
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
)
